
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class IntegrationGrid extends Serenity.EntityGrid<IntegrationRow, any> {
        protected getColumnsKey() { return 'Administration.Integration'; }
        protected getDialogType() { return IntegrationDialog; }
        protected getIdProperty() { return IntegrationRow.idProperty; }
        protected getInsertPermission() { return IntegrationRow.insertPermission; }
        protected getLocalTextPrefix() { return IntegrationRow.localTextPrefix; }
        protected getService() { return IntegrationService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}